<template>
  <div class="month-selector" v-clickoutside="handleHidden">
    <el-link type="primary" @click="showPanal = !showPanal">{{ curMonthFormatter(curMonth) }}</el-link>
    <div class="pannel" :class="{'show': showPanal}">
      <div v-for="opt in options" :key="opt" @click="handleChange(opt)" class="item">
        {{ curMonthFormatter(opt) }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    startTime: {
      type: Number,
      default () {
        return moment(moment().subtract(60, 'months').format('YYYY-MM-01'), 'YYYY-MM-DD').toDate().getTime()
      }
    },
    endTime: {
      type: Number,
      default () {
        return new Date().getTime()
      }
    },
    value: {
      type: Number,
      default () {
        return undefined
      }
    },
    showCurMonth: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  computed: {
    options () {
      const result = []
      for (let time = this.startTime; time < this.endTime; time = moment(time).add(3, 'months').toDate().getTime()) {
        result.unshift(moment(time).startOf('quarter').toDate().getTime())
      }
      return result
    }
  },
  watch: {
    value (newVal, oldVal) {
      if (this.curMonth !== newVal) {
        this.curMonth = newVal
      }
    }
  },
  data () {
    return {
      showPanal: false,
      curMonth: undefined
    }
  },
  methods: {
    handleHidden () {
      this.showPanal = false
    },
    handleChange (opt) {
      this.curMonth = opt
      this.$emit('change', opt)
      this.showPanal = false
    },
    curMonthFormatter (val) {
      if (!val) {
        return moment().format('YYYY') + '-Q' + moment().format('Q')
      }
      return moment(val).format('YYYY') + '-Q' + moment(val).format('Q')
    }
  }
}
</script>
